import { MouseEventHandler } from "react";

interface Props {
  icon: string | undefined;
  className?: string | undefined;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
  style?: React.CSSProperties;
}

function FontIcon({ icon, className = "", onClick, style }: Props) {
  return (
    <i
      onClick={onClick}
      className={`${icon} ${className}`}
      style={style}
    ></i>
  );
}

export default FontIcon;